module.exports = __webpack_public_path__ + "static/media/positivevote.cc60da26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/positivevote.svg
// module id = 647
// module chunks = 0